import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const StyledCardBody = styled(Flex)`
    padding: 24px 28px;
`;

export const StyledVerticalLine = styled.div`
    width: 1px;
    height: 100%;
    background-color: ${colorsPalettes.carbon[100]};
    flex: 0 0 1px;
    min-height: 120px;
    min-width: 1px;
`;

export const StyledGrid = styled.div<{
    columnsNumber: number;
    flex?: string;
    minWidth?: number;
    gap: string;
}>`
    display: grid;
    grid-template-columns: ${({ columnsNumber }) => "auto ".repeat(columnsNumber)};
    min-width: ${({ minWidth }) => minWidth && `${minWidth}px`};
    gap: ${({ gap }) => gap};
    flex: ${({ flex }) => flex};
`;

export const StyledDataItemHeader = styled(Text)`
    white-space: nowrap;
`;
